module.exports = "/images/cover-0.jpg";